export const getBaseURL = () => {
  const cfPagesUrl = import.meta.env.CF_PAGES_URL ?? null; // Does not include protocol, set by cloudflare
  const cfBranch = import.meta.env.CF_PAGES_BRANCH ?? null; // Does not include protocol, set by cloudflare
  const branchAlias = cfBranch
    ? `${cfBranch.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}.www-exchange-trees-cloud.pages.dev`
    : null;
  const viteBaseUrl = import.meta.env.VITE_BASE_URL ?? 'localhost:5173';
  const branchUrl = new URL(`https://${branchAlias}`);
  const currentHost = window.location.host;
  let baseUrl: string;

  // URL can be:
  // - http://localhost:5173 // Local
  // - https://tnc.exchange // Prod
  // - https://dev.tnc.exchange // Dev
  // - https://{branch name}.www-exchange-trees-cloud.pages.dev
  // - https://{build id}.www-exchange-trees-cloud.pages.dev (this is CF_PAGES_URL)

  // If cfBranch && cfPagesUrl is present, we know we are in cloudflare
  if (cfBranch && cfPagesUrl) {
    switch (cfBranch) {
      // Handle custom domains for specific branches
      case 'main':
        baseUrl = 'https://app.tnc.exchange';
        break;
      case 'development':
        baseUrl = 'https://dev.tnc.exchange';
        break;
      default:
        // Not on a branch with a custom domain, so we use the build URL
        // First check to see if the current url matches the branchAlias
        if (branchAlias && branchUrl.host === currentHost) {
          baseUrl = branchAlias;
        } else if (cfPagesUrl) {
          // A cfPagesUrl is present, so we use that (preview urls)
          baseUrl = cfPagesUrl;
        } else {
          // No cfPagesUrl or branchAlias, so we use the viteBaseUrl
          baseUrl = viteBaseUrl;
        }
    }
  } else {
    // Not in cloudflare, so we use the viteBaseUrl
    baseUrl = viteBaseUrl;
  }

  // Remove any trailing slashes first
  baseUrl = baseUrl.replace(/\/+$/, '');

  // Always ensure protocol is present before URL construction
  if (baseUrl.includes('localhost') && !baseUrl.startsWith('http://')) {
    baseUrl = `http://${baseUrl}`;
  } else if (!baseUrl.startsWith('http://') && !baseUrl.startsWith('https://')) {
    baseUrl = `https://${baseUrl}`;
  }

  // Create and validate URL
  try {
    console.log('BASE URL', baseUrl);
    const urlObject = new URL(baseUrl);
    return urlObject.origin;
  } catch (error) {
    throw new Error('Invalid URL', {cause: error});
  }
};

export const getAuthLoginURL = () => {
  try {
    const baseUrl = getBaseURL();
    return new URL('sign-in', baseUrl).toString();
  } catch (error) {
    throw new Error('Error creating auth login URL', {cause: error});
  }
};

export const getAuthCallbackURL = () => {
  try {
    const baseUrl = getBaseURL();
    return `${baseUrl}${import.meta.env.VITE_AUTH_CALLBACK_URL}`;
  } catch (error) {
    throw new Error('Error creating auth callback URL', {cause: error});
  }
};
